<div
  class="gap-[40px] flex flex-col min-h-[calc(100vh-100px)] shrink-0 justify-start items-center pl-[120px] pr-[120px] pt-[64px] pb-[80px] bg-[#F7FAFC] w-[100%] relative">
  <div *ngIf="isLoading" class="flex flex-col items-center justify-center w-full h-full gap-4">
    <div class="loader-spinner w-12 h-12 border-4 border-[#f26f24ff] border-t-transparent rounded-full animate-spin"></div>
    <span class="text-[#111215ff] font-['archivo'] text-[18px]">Loading...</span>
  </div>

  <ng-container *ngIf="!isLoading">
    <div
      class="gap-[40px] flex flex-col w-[100%] max-w-[1480px] shrink-0 justify-start items-center"
      [@pageTransition]="pageTransitionState">
      <div class="w-full flex justify-center">
        <button
          type="button"
          class="inline-flex items-center gap-[8px] h-[40px] px-[16px] rounded-[8px] border border-[#D0D1D4] bg-white text-[#111215] font-['archivo'] text-[14px] leading-[20px] cursor-pointer hover:bg-[#F8F8F8]"
          (click)="goBack()"
          aria-label="Back to Manage Service">
          <span aria-hidden="true">←</span>
          Back to Manage Service
        </button>
      </div>

      <h1 class="text-[#111215] text-center font-bold font-['archivo'] text-[28px] leading-[34px] m-0">
        Reports
      </h1>

      <div class="gap-[28px] flex flex-row flex-wrap w-[100%] shrink-0 justify-center items-stretch">
        <button
          *ngFor="let card of cards; index as i"
          type="button"
          class="relative flex flex-col shrink-0 rounded-[16px] overflow-hidden w-[344px] h-[300px] border-0 p-0 cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#0f172aff] hover:shadow-[0px_8px_20px_0px_rgba(0,0,0,0.18)] hover:-translate-y-1 transition-all duration-300 ease-out"
          [@cardClick]="clickedCard === card.id ? 'clicked' : ''"
          (click)="onCardClick(card, $event)"
          [attr.aria-label]="card.title">
          <div class="absolute inset-0 bg-slate-100">
            <div
              *ngIf="!imagesLoaded[card.id]"
              class="absolute inset-0 w-full h-full image-skeleton"></div>
            <img
              class="w-full h-full object-cover transition-opacity duration-300"
              [src]="'/' + card.image"
              [alt]="card.alt"
              width="344"
              height="300"
              [attr.loading]="i === 0 ? 'eager' : 'lazy'"
              [attr.fetchpriority]="i === 0 ? 'high' : 'low'"
              decoding="async"
              [class.opacity-0]="!imagesLoaded[card.id]"
              [class.opacity-100]="imagesLoaded[card.id]"
              (load)="onImageLoad(card.id)"
              (error)="onImageError(card.id)" />
          </div>
        </button>
      </div>
    </div>
  </ng-container>
</div>
